import "./Users.css";

export default function Users() {
  return <div>Users</div>;
}
